class VariantSelectChips extends HTMLElement {
  chipClassname = 'chip';
  swatchClassname = 'swatch';

  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    if (this.initialized) return;

    if (this.dataset.defer) {// use when custom element is earlier in the document than its bound control
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    if (this.dataset.bind === undefined) return;
    this.select = document.querySelector(this.dataset.bind);
    if (!this.select || !(this.select instanceof HTMLSelectElement)) return;

    const optionsOrder = [3, 0, 1, 2];

    for (let optionIndex of optionsOrder) {
      let option = this.select.options.item(optionIndex);

      if (this.dataset.extra === 'true') {
        const swatchElement = document.createElement('div');
        swatchElement.option = option;
        option.swatch = swatchElement;
        swatchElement.classList.add(this.swatchClassname);
        swatchElement.innerHTML = this.makeSwatchTitle(option);
        this.appendChild(swatchElement);

        swatchElement.addEventListener('click', (e) => {
          this.select.value = swatchElement.option.value;
          this.select.closest('variant-selects').onVariantChange();
          this.updateSwatchStatus();
        });
      } else {
        const chipElement = document.createElement('div');
        chipElement.option = option;
        option.chip = chipElement;
        chipElement.classList.add(this.chipClassname);
        chipElement.innerHTML = this.makeChipTitle(option.value);
        this.appendChild(chipElement);

        chipElement.addEventListener('click', (e) => {
          this.select.value = chipElement.option.value;
          this.select.closest('variant-selects').onVariantChange();
          this.updateChipsStatus();
        });
      }
    }

    this.updateChipsStatus();
    this.updateSwatchStatus();

    window.addEventListener("variantChanged", (e) => {
      this.select.querySelectorAll('option').forEach(option => {
        if (option.value === e.detail.options[0]) {
          if (this.dataset.extra === 'true') {
            option.swatch.classList.add('active');
          } else {
            option.chip.classList.add('active');
          }
        } else {
          if (this.dataset.extra === 'true') {
            option.swatch.classList.remove('active');
          } else {
            option.chip.classList.remove('active');
          }
        }
      });
    });

    this.initialized = true;
  }

  updateChipsStatus() {
    if (this.dataset.extra !== 'true') {
      for (let option of this.select.options) {
        if (option.selected) {
          option.chip.classList.add('active');
        } else {
          option.chip.classList.remove('active');
        }
      }
    }
  }

  updateSwatchStatus() {
    if (this.dataset.extra === 'true') {
      for (let option of this.select.options) {
        if (option.selected) {
          option.swatch.classList.add('active');
        } else {
          option.swatch.classList.remove('active');
        }
      }
    }
  }


  makeChipTitle(value) {
    const parts = value.replace(/\(.*\)/, '').trim().match(/^(.*?)\s*\-\s*(.*?)$/);
    const singleHole = parts[1] === 'Compact' ? '<span class="single">Single Hole</span>' : "";

    const sizes = parts[2].match(/^(.*)\s+x\s+(.*)$/);
    const part2 = sizes ? `${sizes[2]} x ${sizes[1]}` : parts[2];
    return `
      <span>${parts[1]}</span>
      ${singleHole}
      <span>${part2}</span>
    `;
  }

  makeSwatchTitle(value) {
    const parts = value.value.replace(/\(.*\)/, '').trim().match(/^(.*?)\s*\-\s*(.*?)$/);
    return '' +
      '<span class="mobile-heading">' +
      '<span class="swatch__name">' + parts[1] + '</span>' +
      '<span class="swatch-value">' + parts[2] + '</span>' +
      '</span>' +
      '<span class="vertical-divider"></span>'+
      '<span class="swatch__name">' + parts[1] + '</span>' +
      '<img src="' + value.dataset.variantImage + '" class="swatch__image"/>' +
      '<span class="swatch__size"><span class="divider"></span><span class="swatch-value">' + parts[2] + '</span><span class="divider"></span></span>';
  }
}

customElements.define('variant-select-chips', VariantSelectChips);
